// Subject "Calendar" — agenda of open + upcoming questionnaires.
export const calendar = {
  calendar_tab_label: "Calendar",
  calendar_due_before: "To do before {{date}}",
  calendar_opens_on: "Opens on {{date}}",
  calendar_next_time: "Next time: {{date}}",
  calendar_empty: "Nothing planned for now",
};
